<template>
  <div ref="contentToConvert" class="print-panel pdf-modal-popup" :class="{ 'portrait-mode': isPortrait }">
    <div class="layout">
      <div class="portfolio-slide">
        <div class="portfolio-slide-header-btn-wrap button-box">
          <button @click="savePortfolioData(true)" type="button" :disabled="!pdfDownLoadBtn" style="display: none">수정 사항 저장하기</button>
          <button v-if="pdfDownLoadBtn" @click="exportPDF" type="button">저장 및 PDF 다운로드</button>
          <div v-else class="spinner-container" style="margin-right: 50px">
            <div class="btn-spinner" style="width: 100%; height: 100%"></div>
            <div class="spinner-percentage">{{ progress }}%</div>
          </div>
          <button type="button" class="close" @click="closeModal" :disabled="!pdfDownLoadBtn">
            <img src="@/assets/images/icon/ico_close_w.svg" alt="">
          </button>
        </div>
        <div class="swiper-container slider main-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{ 'mobile-style': isMobile }">

              <div v-show="isMobile" class="swiper-slide-button-box-toggle">
                <button type="button" @click="swiperSlideButtonBoxToggle" class="btn" :class="{ 'on': swiperSlideButtonBoxShow }">설정 도구
                  {{ !swiperSlideButtonBoxShow ? '열기' : '닫기' }}
                </button>
              </div>
              <div class="swiper-slide-button-box artwork-page-btn" :class="[{ 'mobile-style': isMobile },{ 'z-up': swiperSlideButtonBoxShow }]">
                <div class="swiper-slide-button-box-title-wrap">
                  <h4>커버 페이지 미리보기</h4>
                </div>
                <div class="view-mode">
                  <p>커버 페이지 텍스트는 자유롭게 수정하여 PDF로 다운로드 할 수 있습니다.<br></p>
                  <p style="color: #FF5C00; font-weight: 600;">'저장 및 PDF 다운로드'를 클릭해도<br><u>수정한 내용은 저장되지 않아요.</u><br></p>
                  <p>
                    <strong>커버 페이지</strong>에 수정한 내용을 계속 사용하고 싶다면,
                    <strong>MY PAGE &gt; ART &amp; ARTISTS &gt; 프로필 관리</strong>에서 내용을 반영해주세요.<br>
                  </p>

                </div>

              </div>

              <div class="inner">
                <div class="frame frame1" @mouseover="showMessage" @mouseleave="hideMessage">
                  <div class="col1">
                    <div class="header-wrap">
                      <em>Portfolio</em>
                      <img src="@/assets/images/icon/ico_shape.png" alt="">
                      <span style="word-break: keep-all">{{ genreInfo.Genre }}</span>
                    </div>

                    <div v-if="artist.nameEn" class="name-en">{{ artist.nameEn }}</div>
                    <h2 v-if="artist.nameKo">{{ artist.nameKo }}</h2>
                    <div class="text-box text-box-introduction portfolio-edit-dashed-box">
                      <button @click="removeTextBox('introduction')" type="button" class="btn_remove">
                        <img src="@/assets/images/icon/ico_close_blue.svg" alt=""/>
                      </button>
                      <textarea ref="introductionTextarea" v-model="artist.introduction" :maxlength="45"></textarea>
                      <div
                          ref="introductionForPDF"
                          class="introduction-pdf-content"
                          :style="{ display: 'none' }"
                      >{{ artist.introduction }}
                      </div>

                    </div>
                    <div class="contact-wrap" :style="{ flexDirection: contactDirection }">
                      <div class="text-box text-box-phoneNum portfolio-edit-dashed-box"
                           :style="{ width: contactDirection === 'row' ? '135px' : '100%' }">
                        <button @click="removeTextBox('phoneNum')" type="button" class="btn_remove">
                          <img src="@/assets/images/icon/ico_close_blue.svg" alt=""/>
                        </button>
                        <input type="tel" inputmode="tel" autocomplete="tel" v-model="artist.phoneNum">
                      </div>
                      <div class="text-box text-box-email portfolio-edit-dashed-box"
                           :style="{ width: contactDirection === 'row' ? 'calc(100% - 135px)' : '100%' }">
                        <button @click="removeTextBox('email')" type="button" class="btn_remove">
                          <img src="@/assets/images/icon/ico_close_blue.svg" alt=""/>
                        </button>
                        <input type="email" inputmode="email" autocomplete="email" ref="editEmail" v-model="artist.email">
                      </div>
                    </div>
                  </div>
                  <div class="col2">
                    <div class="col2-profile-img-wrap portfolio-edit-dashed-box">
                      <button @click="removeImageBox" type="button" class="btn_remove">
                        <img src="@/assets/images/icon/ico_close_blue.svg" alt=""/>
                      </button>
                      <div class="img-wrap">
                        <ImageUploadPreview :preview-image-file="previewImageFile" v-if="previewImageFile"
                                            @update:cropFile="val => selectedCropImageFile = val"
                                            @update:crop-img-url="val => previewImageFile.url = val"
                        />
                        <!--                        <div v-show="isMessageVisible" class="tooltip">-->
                        <!--                          포트폴리오 표지에 들어갈 이미지를 업로드해 주세요. (대표작 사진 등)-->
                        <!--                          표지에 이미지 삽입을 원치 않을 경우 우측 상단의 X 버튼을 누르면 영역이 삭제됩니다.-->
                        <!--                        </div>-->
                      </div>
                    </div>

                  </div>
                  <!--                  <div class="page-info">-->
                  <!--                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""></i>-->
                  <!--                    <span>test-{{ formatPageNumber(1) }}</span>-->
                  <!--                  </div>-->
                </div>

              </div>
            </div>

            <div v-if="!profilePages.length" class="swiper-slide profile-page profile-temp-page">
              <div class="inner">
                <div class="frame frame3" ref="tempProfilePageSplitViewRef">
                  <div class="split-view">
                    <ul>
                      <li ref="profilePageLineWrapHeightTestRef">

                      </li>
                    </ul>
                    <ul v-if="splitModeProfilePage"></ul>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="swiper-slide profile-page" :class="{ 'mobile-style': isMobile }" v-for="(page, index) in profilePages" :key="index">
              <div v-show="isMobile" class="swiper-slide-button-box-toggle">
                <button type="button" @click="swiperSlideButtonBoxToggle" class="btn" :class="{ 'on': swiperSlideButtonBoxShow }">설정 도구
                  {{ !swiperSlideButtonBoxShow ? '열기' : '닫기' }}
                </button>
              </div>
              <div class="swiper-slide-button-box profile-page-btn" :class="[{ 'mobile-style': isMobile },{ 'z-up': swiperSlideButtonBoxShow }]">
                <div class="swiper-slide-button-box-title-wrap">
                  <h4>프로필 미리보기</h4>
                </div>
                <div class="view-mode">
                  <h5>다단 설정</h5>
                  <button @click="splitModeProfilePage = false" class="page-column-btn" :class="{ active: !splitModeProfilePage }">
                    <span>1단</span>
                    <img src="@/assets/images/icon/page_one_column.png" alt="">
                  </button>
                  <button @click="splitModeProfilePage = true" class="page-column-btn" :class="{ active: splitModeProfilePage }">
                    <span>2단</span>
                    <img src="@/assets/images/icon/page_two_column.png" alt="">
                  </button>
                </div>
                <div class="profile-page-data-row-gap view-mode">
                  <h5>줄간격 설정</h5>
                  <div class="profile-page-data-row-gap-button-box">
                    <button @click="profilePageDataRowGap--" :disabled="profilePageDataRowGap <= 0"><img src="@/assets/images/icon/ico_delete_b.svg" alt=""/>
                      좁게
                    </button>
                    <span>{{ profilePageDataRowGap }}</span>
                    <button @click="profilePageDataRowGap++">넓게 <img src="@/assets/images/icon/ico_add3_b.svg" alt=""></button>
                  </div>
                </div>
              </div>
              <div class="inner">
                <div class="frame frame3">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div ref="profilePageSplitViewRef" class="split-view">
                    <ul :style="{ 'row-gap': profilePageDataRowGap + 'px' }">
                      <li v-for="(item, idx) in page.left" :key="idx" class="item" v-safe-html="item"></li>
                    </ul>
                    <ul v-if="splitModeProfilePage && page.right" :style="{ 'row-gap': profilePageDataRowGap + 'px' }">
                      <li v-for="(item, idx) in page.right" :key="idx" class="item" v-safe-html="item"></li>
                    </ul>
                  </div>
                  <div class="page-info">
                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""></i>
                    <span>{{ (index + 2) }}/{{ totalPages }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="artistNotePage" class="swiper-slide profile-page" :class="{ 'mobile-style': isMobile }">
              <div v-show="isMobile" class="swiper-slide-button-box-toggle">
                <button type="button" @click="swiperSlideButtonBoxToggle" class="btn" :class="{ 'on': swiperSlideButtonBoxShow }">설정 도구
                  {{ !swiperSlideButtonBoxShow ? '열기' : '닫기' }}
                </button>
              </div>
              <div class="swiper-slide-button-box profile-page-btn" :class="[{ 'mobile-style': isMobile },{ 'z-up': swiperSlideButtonBoxShow }]">
                <div class="swiper-slide-button-box-title-wrap">
                  <h4>작가 노트 미리보기</h4>
                </div>
                <div class="view-mode">
                  <h5>작성 방법</h5>
                  <p>화면에서 텍스트를 자유롭게 수정해보세요.<br></p>
                  <p style="color: #FF5C00; font-weight: 600;">'저장 및 PDF 다운로드'를 클릭해도<br><u>수정한 내용은 저장되지 않아요.</u><br></p>
                  <p>
                    <strong>작가 노트</strong>에서 수정한 내용을 계속 사용하고 싶다면,
                    <strong>MY PAGE &gt; ART &amp; ARTISTS &gt; 프로필 관리 &gt; 작가 노트</strong>에서 수정 내용을반영해주세요.<br>
                  </p>

                  <textarea v-model="artist.artistNote" class="editor" :class="{ 'error-text-color': isNoteError }"
                            :style="{ 'display': (isMobile && !swiperSlideButtonBoxShow) ? 'none' : ''}"
                            :placeholder="editorPlaceholder"/>

                  <button @click="splitText">노트에 넣기</button>
                  <!--                  <button @click="removeArtistNotePage" class="heart-color-border">노트 생략하기</button>-->
                </div>
              </div>
              <div class="inner">
                <div class="frame frame3">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div class="preview">
                    <div class="preview-text-wrap">
                      <h4>Artist Note</h4>
                    </div>
                    <div class="split-view">
                      <div class="column-box" ref="artistNoteTextBox1" :class="{ 'text-dashed-border': !artistNoteTextFirstPart }"
                           v-safe-html="artistNoteTextFirstPart"></div>
                      <div class="column-box" :class="{ 'text-dashed-border': !artistNoteTextFirstPart }" v-safe-html="artistNoteTextSecondPart"></div>
                    </div>
                  </div>
                  <div class="page-info">
                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""></i>
                    <span>{{ (profilePages.length + 2) }}/{{ totalPages }}</span>
                  </div>
                </div>
              </div>
            </div>


            <div class="swiper-slide" :class="{ 'mobile-style': isMobile }" v-for="(artWork, index) in artWorksPage" :key="index">
              <div v-show="isMobile" class="swiper-slide-button-box-toggle">
                <button type="button" @click="swiperSlideButtonBoxToggle" class="btn" :class="{ 'on': swiperSlideButtonBoxShow }">설정 도구
                  {{ !swiperSlideButtonBoxShow ? '열기' : '닫기' }}
                </button>
              </div>
              <div class="swiper-slide-button-box artwork-page-btn" :class="[{ 'mobile-style': isMobile },{ 'z-up': swiperSlideButtonBoxShow }]">
                <div class="swiper-slide-button-box-title-wrap">
                  <h4>아트워크 미리보기</h4>
                </div>
                <!--                <div class="view-mode"> 사용할거면 다시 작업해야함. 로직 변경으로-->
                <!--                  <p>다단 설정</p>-->
                <!--                  <button @click="splitModeArtWorksPage = false" :class="{ active: !splitModeArtWorksPage }">1쪽 보기</button>-->
                <!--                  <button @click="splitModeArtWorksPage = true" :class="{ active: splitModeArtWorksPage }">2쪽 보기</button>-->
                <!--                </div>-->
                <div v-if="splitModeArtWorksPage && artWork.right?.blobUrl" class="view-mode">
                  <h5>아트워크 분리하기</h5>
                  <p>왼쪽 작품을 단독으로 넣고 싶은 경우 눌러주세요. 오른쪽 작품은 다음 페이지로 이동합니다.</p>
                  <button @click="splitArtwork(index)">분리하기</button>
                </div>
                <div v-else-if="index < artWorksPage.length-1" class="view-mode">
                  <h5>아트워크 합치기</h5>
                  <p>이 페이지에 두 작품을 배치하고 싶은 경우 눌러주세요. 다음 페이지의 첫 작품을 우측에 불러옵니다.</p>
                  <button @click="mergeArtwork(index)">합치기</button>
                </div>
              </div>
              <div class="inner">
                <div class="frame frame4">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div class="split-view">
                    <figure v-if="artWork.left.blobUrl">
                      <div class="artWork-img-area">
                        <img :src="artWork.left.blobUrl" :alt="artWork.left.title || artWork.left.titleEn" class="artwork-img"
                             crossOrigin="anonymous"/>
                      </div>
                      <figcaption>
                        <div class="txt-box">
                          <p>{{ formatArtWorkText(artWork.left) }}</p>
                        </div>
                      </figcaption>
                    </figure>
                    <figure v-if="splitModeArtWorksPage && artWork.right?.blobUrl">
                      <div class="artWork-img-area">
                        <img :src="artWork.right.blobUrl" :alt="artWork.right.title || artWork.right.titleEn" class="artwork-img"
                             crossOrigin="anonymous"/>
                      </div>
                      <figcaption>
                        <div class="txt-box">
                          <p>{{ formatArtWorkText(artWork.right) }}</p>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <div class="page-info">
                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""/></i>
                    <span>{{ (index + profilePages.length + 2 + (artistNotePage ? 1 : 0)) }}/{{ totalPages }}</span>
                  </div>
                </div>
              </div>
            </div>


          </div>

          <div class="swiper-control">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
          <div class="swiper-pagination" style="color: #f0f0f0"></div>
          <div v-show="!isMobile" class="swiper-scrollbar"></div>
        </div>
        <div class="swiper-container thumbnail-swiper">
          <div class="swiper-wrapper">

            <div class="swiper-slide">
              <div class="inner">
                <div class="frame frame1">
                  <div class="col1">
                    <div class="header-wrap">
                      <em>Portfolio</em>
                      <img src="@/assets/images/icon/ico_shape.png" alt="">
                      <span>{{ genreInfo.Genre }}</span>
                    </div>

                    <div v-if="artist.nameEn" class="name-en">{{ artist.nameEn }}</div>
                    <h2 v-if="artist.nameKo">{{ artist.nameKo }}</h2>
                    <div class="text-box text-box-introduction portfolio-edit-dashed-box">
                      <textarea v-model="artist.introduction" :maxlength="45" readonly></textarea>
                    </div>
                    <div class="contact-wrap" :style="{ flexDirection: contactDirection }">
                      <div class="text-box text-box-phoneNum portfolio-edit-dashed-box"
                           :style="{ width: contactDirection === 'row' ? '135px' : '100%' }">
                        <input type="tel" inputmode="tel" autocomplete="tel" v-model="artist.phoneNum" readonly>
                      </div>
                      <div class="text-box text-box-email portfolio-edit-dashed-box"
                           :style="{ width: contactDirection === 'row' ? 'calc(100% - 135px)' : '100%' }">
                        <input type="email" inputmode="email" autocomplete="email" ref="editEmail" v-model="artist.email" readonly>
                      </div>
                    </div>
                  </div>
                  <div class="col2">
                    <div class="col2-profile-img-wrap portfolio-edit-dashed-box">
                      <div class="img-wrap">
                        <img v-if="previewImageFile" :src="previewImageFile.url" alt="포트폴리오 표지 미리보기"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide profile-page" v-for="(page, index) in profilePages" :key="index">
              <div class="inner">
                <div class="frame frame3">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div ref="profilePageSplitViewRef" class="split-view">
                    <ul :style="{ 'row-gap': profilePageDataRowGap + 'px' }">
                      <li v-for="(item, idx) in page.left" :key="idx" class="item" v-safe-html="item" style="font-family: 'SUIT';"></li>
                    </ul>
                    <ul v-if="splitModeProfilePage && page.right" :style="{ 'row-gap': profilePageDataRowGap + 'px' }">
                      <li v-for="(item, idx) in page.right" :key="idx" class="item" v-safe-html="item" style="font-family: 'SUIT';"></li>
                    </ul>
                  </div>
                  <!--                  <div class="page-info">-->
                  <!--                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""></i>-->
                  <!--                    <span>{{ (index + 1) }}/{{ totalPages }}</span>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>


            <div v-if="artistNotePage" class="swiper-slide profile-page">
              <div class="inner">
                <div class="frame frame3">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div class="preview">
                    <div class="preview-text-wrap">
                      <h4>ArtistNote</h4>
                    </div>
                    <div class="split-view">
                      <div class="column-box" v-safe-html="artistNoteTextFirstPart"></div>
                      <div class="column-box" v-safe-html="artistNoteTextSecondPart"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="swiper-slide" v-for="(artWork, index) in artWorksPage" :key="index">
              <div class="inner">
                <div class="frame frame4">
                  <div class="page-header">
                    <div v-if="artist.nameEn || artist.nameKo" class="name-with-line">
                      <span class="name">{{ artist.nameEn || artist.nameKo }}</span>
                      <div class="line"></div>
                    </div>
                  </div>
                  <div class="split-view">
                    <figure v-if="artWork.left.blobUrl">
                      <div class="artWork-img-area">
                        <img :src="artWork.left.blobUrl" :alt="artWork.left.title || artWork.left.titleEn" class="artwork-img"/>
                      </div>
                      <figcaption>
                        <div class="txt-box">
                          <p>{{ formatArtWorkText(artWork.left) }}</p>
                        </div>
                      </figcaption>
                    </figure>
                    <figure v-if="splitModeArtWorksPage && artWork.right?.blobUrl">
                      <div class="artWork-img-area">
                        <img :src="artWork.right.blobUrl" :alt="artWork.right.title || artWork.right.titleEn" class="artwork-img"/>
                      </div>
                      <figcaption>
                        <div class="txt-box">
                          <p>{{ formatArtWorkText(artWork.right) }}</p>
                        </div>
                      </figcaption>
                    </figure>
                  </div>
                  <!--                  <div class="page-info">-->
                  <!--                    <i><img src="@/assets/images/icon/ico_shape.png" alt=""/></i>-->
                  <!--                    <span>{{ (index + profilePages.length + 1) }}/{{ totalPages }}</span>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, ref, computed, onMounted, onBeforeUnmount, nextTick, defineProps, watch, onUnmounted} from 'vue';
import {ARTIST_EXPERIENCES, ARTIST_ACTIVITY_GENRES, ARTIST_EDUCATIONS, ARTIST_EDUCATIONS_STATUS} from "@/common/common-enum";
import Swiper from "swiper";
import $ from "jquery";
import {jsPDF} from "jspdf";
import html2canvas from "html2canvas";
import {useUiStore} from "@/store/useUiStore";
import {apiClient} from "@/services/auth-header";
import ImageUploadPreview from "@/components/ui/ImageUploadPreview.vue";
import {debounce} from "@/common/common-function";
import {getTempBox, destroyTempBox} from "@/utils/tempBox";
import {useSlack} from '@/composables/useSlack';

const {sendErrorMessage} = useSlack();
const uiStore = useUiStore();
const progress = ref(0);
const props = defineProps({
  artist: Object,
  artWorks: Object,
  pdfSettingConfig: Object,
  fieldVisibility: Object,
  profilePageLayoutConfig: Object,
  autoDownload: {type: Boolean, default: false},
  artWorksPortfolioCategory: String,
  blobUrlMap: Object,
});

const swiperSlideButtonBoxShow = ref(false);
const swiperSlideButtonBoxToggle = () => {
  swiperSlideButtonBoxShow.value = !swiperSlideButtonBoxShow.value;
}

const artist = ref(props.artist);

// orientation 계산 (portrait/landscape)
const isPortrait = computed(() => props.pdfSettingConfig?.orientation === 'portrait');

const emit = defineEmits(["close", "downloaded"]); // , "update:field-visibility" <- 여기서 업데이트x. 프로필관리에서.
const loadingMessage = '원본 이미지를 불러오는 중입니다. 이미지 용량에 따라 시간이 다소 소요될 수 있습니다.';

/** 표지 s */
const isMessageVisible = ref(false);
const previewImageFile = ref(null);
const selectedCropImageFile = ref(null);

const showMessage = () => {
  isMessageVisible.value = true;
  // setTimeout(() => {
  //   hideMessage();
  // }, 1000)
}
const hideMessage = () => isMessageVisible.value = false;

const formatPageNumber = (number) => number < 10 ? '0' + number : number.toString();
const formatPhoneNumber = (num) => {
  const raw = num;
  if (raw.length === 11) {
    return raw.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  return num; // 포맷 안 맞으면 그대로
};

const contactDirection = ref('row'); // 초기 방향
const editEmail = ref(null);
let emailLength = 0;

watch(() => artist.value.email, () => {
  nextTick(() => {
    const inputEmail = editEmail.value;
    if (!inputEmail) {
      return;
    }

    const isOverflowing = inputEmail.scrollWidth > 225;  //inputEmail.clientWidth = 255
    if (!isOverflowing) {
      return;
    }

    if (emailLength === 0) {
      contactDirection.value = 'column';
      emailLength = artist.value.email.length;
    } else if (artist.value.email.length < emailLength) {
      contactDirection.value = 'row';
      emailLength = 0;
    }

  });
});

// 텍스트 박스 제거 함수
const removeTextBox = (targetName) => {
  const target = '.text-box-' + targetName;
  $(`${target}`).remove();
  artist.value[targetName] = '';
};

// 이미지 박스 제거 함수
const removeImageBox = () => {
  $(".col2").remove();
};

// 이미지 업로드 미리보기 함수
const previewUploadImage = async (event) => {
  const file = event.target.files[0];
  const url = await toDataURL(URL.createObjectURL(file));
  const imgElement = new Image();
  imgElement.src = url;
  previewImageFile.value = {name: file.name, url, type: file.type};
  hideMessage();
};

const toDataURL = async (src) => {
  let blob = await fetch(src).then(r => r.blob());
  return await new Promise((resolve) => {
    let reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const totalPages = computed(() => {
  // 표지 + 프로필 + 아트워크 + 작가노트
  return 1 + profilePages.value.length + artWorksPage.value.length + (artistNotePage.value ? 1 : 0);
});
/** 표지 e */

/** pdf s */
const pdfDownLoadBtn = ref(true);
const introductionTextarea = ref();
const introductionForPDF = ref();

const autoDownload = async () => {
  await exportPDF();
  emit('downloaded');
  emit('close');
}

const exportPDF = async () => {
  await nextTick();

  if (!confirm("PDF 저장 하시겠습니까?")) {
    return;
  }

  progress.value = 0;
  pdfDownLoadBtn.value = false;

  const elements = document.querySelectorAll('.portfolio-edit-dashed-box');
  elements.forEach(el => {
    el.dataset.oldBorder = el.style.border;
    el.style.border = 'none';
  });

  $(".btn_remove").hide();
  $(".swiper-slide-button-box").hide();
  introductionTextarea.value.style.display = 'none';
  introductionForPDF.value.innerText = artist.value.introduction;
  introductionForPDF.value.style.display = 'block';

  try {
    const {pageWidth, pageHeight, orientation, scale, imageQuality} = props.pdfSettingConfig;
    const pdf = new jsPDF({
      orientation,
      unit: 'mm',
      format: [pageWidth, pageHeight]
    });

    const swiperContainer = mainSwiper.value.el;
    const inners = Array.from(swiperContainer.querySelectorAll('.inner'));

    const batchSize = 5;

    for (let i = 0; i < inners.length; i += batchSize) {
      const batch = inners.slice(i, i + batchSize);

      for (const [j, inner] of batch.entries()) {
        const innerWidth = inner.scrollWidth;
        const innerHeight = inner.scrollHeight;

        await new Promise(resolve => setTimeout(resolve, 300)); // 렌더링 안정화

        const canvas = await html2canvas(inner, {
          allowTaint: false,
          useCORS: true,
          width: innerWidth,
          height: innerHeight,
          scale
        });

        const imgData = canvas.toDataURL('image/jpeg', imageQuality); // PNG → JPEG로 변경

        if (i + j > 0) {
          pdf.addPage();
        }

        const pdfPageWidth = pdf.internal.pageSize.getWidth();
        const pdfPageHeight = pdf.internal.pageSize.getHeight();

        const widthRatio = pdfPageWidth / canvas.width;
        const heightRatio = pdfPageHeight / canvas.height;
        const scaleRatio = Math.min(widthRatio, heightRatio);

        const imgWidth = canvas.width * scaleRatio;
        const imgHeight = canvas.height * scaleRatio;

        const xOffset = (pdfPageWidth - imgWidth) / 2;
        const yOffset = (pdfPageHeight - imgHeight) / 2;

        pdf.addImage(imgData, 'JPEG', xOffset, yOffset, imgWidth, imgHeight);
        progress.value = Math.floor(((i + j + 1) / inners.length) * 96);

        // 메모리 해제
        canvas.width = 0;
        canvas.height = 0;
      }
    }

    const pdfName = `${artist.value.nameKo}-portfolio-${getTodayStr()}.pdf`;
    const s3Prefix = await savePortfolioData(false);
    await uploadPDFToS3(s3Prefix, pdfName, pdf);

    pdf.save(pdfName);
    progress.value = 100;

    const msg =
        "PDF 파일 다운로드가 완료되었습니다.\n\n"
        + "가장 최근 제작한 포트폴리오는 아래 경로를 통해 다시 다운로드할 수 있습니다.\n\n"
        + "마이페이지 > 포트폴리오 제작 > 최근 포트폴리오 불러오기 > 포트폴리오 파일 생성";
    alert(msg);

  } catch (error) {
    console.error(error);
    await savePortfolioData(true);
    alert("포트폴리오 제작 시 오류가 발생하면 1:1 문의를 통해 알려주세요. 빠르게 조치해 드리겠습니다.");
  } finally {
    pdfDownLoadBtn.value = true;
    $(".btn_remove").show();
    $(".swiper-slide-button-box").show();
    elements.forEach(el => {
      el.style.border = el.dataset.oldBorder || '';
    });

    introductionForPDF.value.style.display = 'none';
    introductionTextarea.value.style.display = 'block';
  }
};

async function uploadPDFToS3(s3Prefix, pdfName, pdf) {
  try {


    // 1. PDF → Blob
    const pdfBlob = pdf.output('blob');

    const pdfMaxSize = 1000;
    if (pdfBlob.size > pdfMaxSize * 1024 * 1024) { // MB 체크
      console.log(`PDF 용량이 너무 큽니다. ${pdfMaxSize}MB 이하로 만들어주세요.`);
      await sendErrorMessage(`PDF 용량이 너무 큽니다. ${pdfMaxSize}MB`)
      return;
    }

    const contentType = 'application/pdf';
    // 2. Presigned URL 요청
    const res = await apiClient.get('/v1/s3/put/presigned-url', {
      params: {
        fileName: s3Prefix + pdfName,
        contentType: contentType
      }
    });

    const presignedUrl = res.data;

    // 3. S3로 직접 업로드
    const uploadRes = await fetch(presignedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType
      },
      body: pdfBlob
    });

    if (!uploadRes.ok) {
      throw new Error('S3 업로드 실패');
    }

    const segments = s3Prefix.split('/');
    const id = segments[segments.length - 2];
    await markPdfAsSaved(id);

    // 4. 최종 파일 접근 URL
    const fileUrl = presignedUrl.split('?')[0];

    return fileUrl;
  } catch (error) {
    console.error('❌ PDF 업로드 에러:', error);
    const errorMsg = error?.message || String(error);
    const shortMsg = errorMsg.length > 100 ? errorMsg.substring(0, 100) + '...' : errorMsg;

    await sendErrorMessage(`❌ ${s3Prefix + pdfName} PDF 업로드 에러: ${shortMsg}`);

    return null;
  }
}

const markPdfAsSaved = async (id) => {
  try {
    await apiClient.put(`/v1/artists/me/portfolio/${id}/pdf/saved`)
    console.log('✅ PDF 저장 완료 처리됨')
  } catch (error) {
    console.error('❌ PDF 저장 상태 업데이트 실패:', error)
  }
}

function getTodayStr() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
}

const updateArtWorksPageAndSide = async () => {
  artWorksPage.value.forEach((pair, index) => {
    Object.entries(pair).forEach(([key, item]) => {
      if (item) {
        const matched = props.artWorks.find(art => art.uuid === item.uuid);
        matched.page = index;
        matched.side = key;
      }
    });
  });
}

const savePortfolioData = async (isTemporary = true, pdf, pdfName) => {
  const profilePageLayoutConfig = {
    profilePageDataRowGap: profilePageDataRowGap.value,
    profilePageDataBlankEl: {},
    splitModeProfilePage: splitModeProfilePage.value
  };

  // profilePageDataBlankEl.value가 빈 값이 아닐 때만 포함시키기
  if (profilePageDataBlankEl.value && Object.keys(profilePageDataBlankEl.value).length > 0) {
    profilePageLayoutConfig.profilePageDataBlankEl = profilePageDataBlankEl.value;
  }

  await updateArtWorksPageAndSide();

  // 빈칸도 저장해야함. 표지 변경가능한 데이터들도 추가하기.
  const formData = new FormData();

  const reqDto = {
    artistProfile: {...props.artist},
    artistArtWorks: [...props.artWorks],
    profileVisibility: {...props.fieldVisibility},
    profilePageLayoutConfig: profilePageLayoutConfig,
    pdfSettingConfig: {...props.pdfSettingConfig},
  };

  formData.append('reqDto', new Blob([JSON.stringify(reqDto)], {type: 'application/json'}));

  formData.append('isTemporary', String(isTemporary));

  if (selectedCropImageFile.value) {
    formData.append('image', selectedCropImageFile.value);
  }

  if (!isTemporary && pdf && !props.artist) {
    const blob = pdf.output("blob");
    formData.append("pdf", blob, pdfName);
  }

  try {
    const response = await apiClient.post('/v1/artists/me/portfolio', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;

  } catch (error) {
    console.error('Error saveProfile data:', error);
  }

}
/** pdf e */

/** artist profile s */
/* profile 데이터 세팅  **/
const genreInfo = computed(() => {
  if (
      !props.fieldVisibility.activityGenreTypes ||
      !artist.value.activityGenreTypes ||
      artist.value.activityGenreTypes.length === 0
  ) {
    return {};
  }

  const genreList = artist.value.activityGenreTypes
  .filter(item => item.selected)
  .map(item =>
      artistActivityGenresMap[item.value].value !== 'ETC'
          ? artistActivityGenresMap[item.value].label
          : artist.value.activityGenreEtc
  )
  .join(', ');

  if (!genreList) {
    return {};
  }

  return {
    Genre: genreList,
  };
});

const artistEducationsStatusMap = ARTIST_EDUCATIONS_STATUS.reduce((map, item) => {
  map[item.value] = item;
  return map;
}, {});

const artistActivityGenresMap = ARTIST_ACTIVITY_GENRES.reduce((map, item) => {
  map[item.value] = item;
  return map;
}, {});

const groupedExperiences = computed(() => {
  return ARTIST_EXPERIENCES.reduce((acc, experiences) => {
    acc[experiences.value] = artist.value.experiences
    .filter(exp => exp.type === experiences.value)
    .sort((a, b) => b.year - a.year); // 최신 연도순 정렬
    return acc;
  }, {});
});

const allInfo = ref({});
const profilePageDataBlankEl = ref({});

const setProfileData = async () => {

  if (artist.value.educations && artist.value.educations.length > 0) {
    const ARTIST_EDUCATIONS = [
      {value: 'GRADUATE', label: '대학원'},
      {value: 'UNDERGRADUATE', label: '학부'},
      {value: 'ETC', label: '기타'},
    ]
    // 출력 순서: 대학원 > 학부 > 기타, 라벨은 첫번째꺼만 출력.
    const displayTitle = 'Education';
    allInfo.value[displayTitle] = ARTIST_EDUCATIONS.flatMap(({value, label}) => {
      if (!props.fieldVisibility[value]) {
        return;
      }
      const filtered = artist.value.educations
      .filter((item) => item.type === value)
      .filter(item => item.selected)
      .map((item, index) => {
        const displayLabel = index === 0 ? label : '';  // 첫 번째 항목만 라벨 표시
        const statusLabel = artistEducationsStatusMap[item.status]?.label || '';
        return `
          <span class="label ko" style="">${displayLabel}</span>
          <span class="separator">|</span>
          <span class="year">${item.year}</span>
          <div class="rest">
            <span class="schoolName">${item.schoolName}</span>
            <span class="separator">|</span>
            <span class="major">${item.major}</span>
            <span class="separator">|</span>
            <span class="status"> ${statusLabel}</span>
          </div>
      `;
      });
      return filtered;
    }).filter(Boolean);
    if (allInfo.value[displayTitle].length) {
      setProfileDataTitleAndBlackEl(displayTitle);
    }
  }

  appendExperienceInfo('SOLO_EXHIBITION', 'Solo Exhibition', groupedExperiences.value, props.fieldVisibility);
  appendExperienceInfo('GROUP_EXHIBITION', 'Group Exhibition', groupedExperiences.value, props.fieldVisibility);
  appendExperienceInfo('RESIDENCY', 'Residency', groupedExperiences.value, props.fieldVisibility);
  appendExperienceInfo('WORKSHOP', 'Workshop', groupedExperiences.value, props.fieldVisibility);
  appendExperienceInfo('GRANT', 'Grant', groupedExperiences.value, props.fieldVisibility);

  if (props.fieldVisibility['awards'] && artist.value.awards && artist.value.awards.length > 0) {
    const displayTitle = 'Award';
    allInfo.value[displayTitle] = artist.value.awards
    .filter(item => item.selected)
    .map(item => {
      return `
        <span class="year">${item.year}</span>
        <div class="rest">
          <span class="title">${item.title}</span>
        </div>
      `;
    });
    if (allInfo.value[displayTitle].length) {
      setProfileDataTitleAndBlackEl(displayTitle);
    }

  }

  if (props.fieldVisibility['collections'] && artist.value.collections && artist.value.collections.length > 0) {
    const displayTitle = 'Collection';
    allInfo.value[displayTitle] = artist.value.collections
    .filter(item => item.selected)
    .map(item => {
      return `
         <span class="place">${item.name}</span>
      `;
    });
    if (allInfo.value[displayTitle].length) {
      allInfo.value[displayTitle].unshift(`<h3>${displayTitle}</h3>`);
      //     setProfileDataTitleAndBlackEl(displayTitle); 마지막이라 제목만.
    }
  }
}

const appendExperienceInfo = (fieldKey, displayTitle, grouped, visibilityMap) => {
  if (
      visibilityMap[fieldKey] &&
      grouped[fieldKey] &&
      grouped[fieldKey].length
  ) {
    allInfo.value[displayTitle] = grouped[fieldKey]
    .filter(item => item.selected)
    .map(item => {
      return `
        <span class="year">${item.year}</span>
        <div class="rest">
          <span class="title">${item.title}</span>
          <span class="separator">|</span>
          <span class="place">${item.location}</span>
          <span class="separator">|</span>
          <span class="region">${item.region}</span>
        </div>
      `;
    });
    if (allInfo.value[displayTitle].length) {
      setProfileDataTitleAndBlackEl(displayTitle);
    }

  }
};

const setProfileDataTitleAndBlackEl = (displayTitle) => {
  allInfo.value[displayTitle].unshift(`<h3>${displayTitle}</h3>`);
  allInfo.value[displayTitle].push(blankEl(displayTitle, 'right-blank'));
  const count = profilePageDataBlankEl.value[displayTitle] || 0;
  for (let i = 0; i < count; i++) {
    allInfo.value[displayTitle].push(blankEl(displayTitle));
  }
}

const blankEl = (key, className = 'left-blank', num = 0) => {
  const shade = 255 - ((num + 1) * 10); // 255 → 105 (10단계)
  const color = `rgb(${shade}, ${shade}, ${shade})`;
  return `<div class="blank-line" data-key="${key}" style="background-color: ${color};"><div class="${className}"></div><br/></div>`;
};

/* blankEl 빈칸 클릭 이벤트 */
const profilePageSplitViewRef = ref(null);
const addClickEvent = () => {
  profilePageSplitViewRef.value?.forEach((parentEl) => {
    if (!(parentEl instanceof HTMLElement)) {
      return;
    } // DOM 요소인지 확인

    parentEl.querySelectorAll(".left-blank").forEach((el) => {
      el.removeEventListener("click", handleLeftClick);
      el.addEventListener("click", handleLeftClick);
    });

    parentEl.querySelectorAll(".right-blank").forEach((el) => {
      el.removeEventListener("click", handleRightClick);
      el.addEventListener("click", handleRightClick);
    });
  });
};

const handleLeftClick = (event) => {
  // 가장 가까운 .blank-line 요소 찾기
  const blankLineElement = event.target.closest(".blank-line");
  if (!blankLineElement) {
    console.warn("❌ .blank-line 요소를 찾을 수 없음.");
    return;
  }
  const key = blankLineElement.getAttribute("data-key");
  if (!key) {
    console.warn("❌ data-key 값이 없음.");
    return;
  }

  if (allInfo.value[key] && allInfo.value[key].length > 1) {
    allInfo.value[key].pop();
    profilePageDataBlankEl.value[key] = (profilePageDataBlankEl.value[key] || 0) - 1;

    paginateProfileData();
  }
};

const handleRightClick = (event) => {
  // 가장 가까운 .blank-line 요소 찾기
  const blankLineElement = event.target.closest(".blank-line");
  if (!blankLineElement) {
    console.warn("❌ .blank-line 요소를 찾을 수 없음.");
    return;
  }
  const key = blankLineElement.getAttribute("data-key");
  if (!key) {
    console.warn("❌ data-key 값이 없음.");
    return;
  }

  profilePageDataBlankEl.value[key] = (profilePageDataBlankEl.value[key] || 0) + 1;
  allInfo.value[key].push(blankEl(key, 'left-blank', profilePageDataBlankEl.value[key]));
  paginateProfileData();
};

/* 데이터가 세팅된 후, 페이지 나누기 계산 */
const splitModeProfilePage = ref(true);
const profilePages = ref([]);
let profilePageHeight = 0; // ✅ 한 페이지에서 허용되는 최대 높이(px)

const profilePageDataRowGap = ref(0);

const tempProfilePageSplitViewRef = ref(null);
const profilePageLineWrapHeightTestRef = ref(null);

function calculateElementHeight(element) {
  const elementStyle = window.getComputedStyle(element);
  const paddingTop = elementStyle.paddingTop;
  const paddingTopValue = parseFloat(paddingTop, 10);
  const paddingBottom = elementStyle.paddingBottom;
  const paddingBottomValue = parseFloat(paddingBottom, 10);
  return element.clientHeight - paddingTopValue - paddingBottomValue;
}

const paginateProfileData = async () => {
  profilePages.value = [];

  await nextTick();

  if (profilePageHeight === 0) {
    const splitViewElement = tempProfilePageSplitViewRef.value;
    profilePageHeight = calculateElementHeight(splitViewElement);
  }

  let pages = [];
  let currentPageData = [];
  let currentHeight = 0;

  const lineWrapHeightTestLiElement = profilePageLineWrapHeightTestRef.value; // ul 내부의 li 요소 선택

  let itemHeight = 0;
  Object.keys(allInfo.value).forEach((key) => {
    allInfo.value[key].forEach((item) => {
      lineWrapHeightTestLiElement.innerHTML = item;
      let estimatedHeight = lineWrapHeightTestLiElement.getBoundingClientRect().height; // 추가 후 높이 측정
      itemHeight = estimatedHeight + profilePageDataRowGap.value;

      if (currentHeight + itemHeight > profilePageHeight) {
        pages.push([...currentPageData]);
        currentPageData = [];
        currentHeight = 0;
      }

      currentPageData.push(item);
      currentHeight += itemHeight;
    });
  });

  if (currentPageData.length > 0) {
    pages.push(currentPageData);
  }

  // 실질적 콘텐츠가 있는지 확인 (blankEl만 있는 페이지는 빈 페이지로 간주)
  const hasContent = (pageData) => {
    return pageData && pageData.length > 0 && pageData.some(item => !item.includes('blank-line'));
  };

  // 마지막 페이지가 빈 콘텐츠(blankEl만)면 제거
  while (pages.length > 0 && !hasContent(pages[pages.length - 1])) {
    pages.pop();
  }

  // **2분할 모드일 경우, 좌우 나누기**
  if (splitModeProfilePage.value) {
    let splitPages = [];
    for (let i = 0; i < pages.length; i += 2) {
      splitPages.push({
        left: pages[i],
        right: pages[i + 1] || [] // 오른쪽이 없으면 빈 배열
      });
    }
    profilePages.value = splitPages;
  } else {
    // 기존 단일 페이지 모드
    profilePages.value = pages.map(page => ({left: page}));
  }
  await updateSwiper();
};

const watchProfilePageLayoutConfig = async () => {
  await nextTick();
  watch(profilePageDataRowGap, () => {
    paginateProfileData();
  });

  watch(splitModeProfilePage, () => {
    paginateProfileData();
  });
}
/** artist profile e */

/** artwork s */
const splitModeArtWorksPage = ref(true);
const artWorksPage = ref([]);

const getPresignedUrls = async (artWorkUuid) => {

  try {
    const response = await apiClient.get('/v1/artists/me/artworks/file-urls', {
      params: {
        artworkUuids: [artWorkUuid] // 배열로 전달
      },
      paramsSerializer: params => {
        return new URLSearchParams(params).toString();
      }
    });

    if (response.status === 200) {
      const fileUrls = response.data.urls ?? [];
      return fileUrls;
    }

  } catch (error) {
    console.error("Error deleting artwork:", error);
    // } finally {
  }
}

const getPresignedUrlsWithArtworkUuids = async (artWorkUuid) => {

  try {
    const response = await apiClient.get('/v1/artists/me/artworks/private-presigned-urls-with-artworkUuids', {
      params: {
        artworkUuids: [artWorkUuid] // 배열로 전달
      },
      paramsSerializer: params => {
        return new URLSearchParams(params).toString();
      }
    });

    if (response.status === 200) {
      const fileUrlMap = response.data.urlMap ?? {};
      return fileUrlMap;
    }

  } catch (error) {
    console.error("Error deleting artwork:", error);
    // } finally {
  }
}

const getPublicPresignedUrls = async (imageUrls) => {

  try {
    const response = await apiClient.get('/v1/artists/me/public-presigned-urls', {
      params: {
        imageUrls: [imageUrls] // 배열로 전달
      },
      paramsSerializer: params => {
        return new URLSearchParams(params).toString();
      }
    });

    if (response.status === 200) {
      const fileUrls = response.data.urls ?? [];
      return fileUrls;
    }

  } catch (error) {
    console.error("Error deleting artwork:", error);
    // } finally {
  }
}

const toBlobUrlWithUuid = async (uuid, url, map) => {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    map.set(uuid, blobUrl);
    return blobUrl;
  } catch (error) {
    console.error("fetch err :", error);
    return url;
  }
}

// 유틸: 동시에 N개만 실행
const limitConcurrency = async (tasks, limit = 5, onProgress) => {
  const results = [];
  const executing = [];

  for (const task of tasks) {
    const p = task().then(result => {
      executing.splice(executing.indexOf(p), 1);
      if (onProgress) {
        onProgress();
      } // ✅ 진행도 콜백
      return result;
    });

    results.push(p);
    executing.push(p);

    if (executing.length >= limit) {
      await Promise.race(executing);
    }
  }

  return Promise.all(results);
};

const totalCount = ref(0);
const completedCount = ref(0);

const loadBlobUrlsWithCache = async (uuidList) => {
  // 캐시 여부 체크
  const uncachedUuids = uuidList.filter(uuid => !props.blobUrlMap.has(uuid));
  const cachedCount = uuidList.length - uncachedUuids.length;

  totalCount.value = uuidList.length; // 전체 UUID 수 기준
  completedCount.value = cachedCount; // 이미 캐시된 수만큼 완료로 설정
  uiStore.showLoading(loadingMessage + `(${completedCount.value} / ${totalCount.value})`);

  if (uncachedUuids.length > 0) {
    const presignedUrlsMap = await getPresignedUrlsWithArtworkUuids(uncachedUuids);
    const blobTasks = Object.entries(presignedUrlsMap).map(([uuid, url]) => () =>
        toBlobUrlWithUuid(uuid, url, props.blobUrlMap)
    );

    await limitConcurrency(blobTasks, 5, () => {
      completedCount.value++;
      uiStore.showLoading(loadingMessage + `(${completedCount.value} / ${totalCount.value})`);
    });

    uiStore.hideLoading(); // 완료 시 로딩 종료
  }

  return uuidList.map(uuid => props.blobUrlMap.get(uuid));
};

const paginateArtWorksData = async () => {
  artWorksPage.value = [];

  await nextTick();

  let pages = props.artWorks
  .filter(item => item.categoryUuid === props.artWorksPortfolioCategory)
  .sort((a, b) => a.categorySortOrder - b.categorySortOrder);

  //const imageUrlList = pages.map(item => item.imageUrl);
  //const publicPresignedUrls = await getPublicPresignedUrls(imageUrlList);

  const uuidList = pages.map(item => item.uuid);

  // const presignedUrls = await getPresignedUrls(uuidList);
  // const blobUrls = await Promise.all(presignedUrls.map(toBlobUrl))
  // const blobUrls = await loadBlobUrlsWithLimit(presignedUrls, 5)
  // 부모에서 blobs 관리.
  const blobUrls = await loadBlobUrlsWithCache(uuidList);

  pages = pages.map((item, idx) => ({
    ...item,
    blobUrl: blobUrls[idx],
  }))

  const splitPages = [];

  // 세로 모드일 때: 이미지 비율에 따라 그룹화
  if (isPortrait.value) {
    // 이미지 크기 정보 가져오기
    const pagesWithSize = await Promise.all(pages.map(async (item) => {
      if (!item.blobUrl) return { ...item, isLandscape: false };
      const size = await getImageSize(item.blobUrl);
      return { ...item, isLandscape: size.width > size.height };
    }));

    // 가로형은 2개씩, 세로형은 1개씩 배치
    let i = 0;
    while (i < pagesWithSize.length) {
      const current = pagesWithSize[i];
      const next = pagesWithSize[i + 1];

      if (current.isLandscape && next && next.isLandscape) {
        // 둘 다 가로형이면 같은 페이지에 위아래로 배치
        splitPages.push({ left: current, right: next });
        i += 2;
      } else {
        // 세로형이거나 다음이 없으면 단독 배치
        splitPages.push({ left: current, right: null });
        i += 1;
      }
    }
  } else {
    // 기존 가로 모드 로직
    const grouped = {};

    // page 번호 기준으로 left/right 그룹화
    pages.forEach(p => {
      if (!grouped[p.page]) {
        grouped[p.page] = {};
      }
      grouped[p.page][p.side] = p;
    });

    // 페이지 번호 순으로 정렬 후 splitPages 구성
    Object.keys(grouped).sort((a, b) => a - b).forEach(pageNum => {
      const pair = grouped[pageNum];
      splitPages.push({
        left: pair.left || null,
        right: pair.right || null,
      });
    });
  }

  artWorksPage.value = splitPages;
  await updateSwiper();
};

// 이미지 크기 가져오기
const getImageSize = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = () => resolve({ width: 1, height: 1 });
    img.src = src;
  });
};

// 아트워크 분리
const splitArtwork = async (index) => {
  // 데이터를 깊은 복사하여 변경
  const updatedData = JSON.parse(JSON.stringify(artWorksPage.value));
  if (updatedData[index].right === null) {
    return;
  }
  const carryOver = {'left': updatedData[index].right, 'right': null};
  updatedData[index].right = null;
  updatedData.splice(index + 1, 0, carryOver);
  artWorksPage.value = updatedData;
  await updateSwiper();
};

//아트워크 합체
const mergeArtwork = async (index) => {
  const updatedData = JSON.parse(JSON.stringify(artWorksPage.value));

  if (updatedData[index].right !== null || !updatedData[index + 1]?.left) {
    return;
  }

  updatedData[index].right = updatedData[index + 1].left;
  updatedData[index + 1].left = updatedData[index + 1].right;
  updatedData[index + 1].right = null;
  if (!updatedData[index + 1].left) {
    updatedData.splice(index + 1, 1);
  }
  artWorksPage.value = updatedData;
  await updateSwiper();
};

const formatArtWorkText = (artWork) => {
  let formattedText = [artWork.title, artWork.titleEn].filter(Boolean).join(' | ');

  // 캡션 노출 순서: 연도 > 재료 > 크기 (갤러리 뷰어와 동일 기준)
  const additionalInfo = [artWork.year, artWork.material, artWork.size].filter(Boolean).join(' | ');

  if (additionalInfo) {
    formattedText += `\n${additionalInfo}`;
  }

  return formattedText;
};

/** artwork e */

/** 작가 노트 s */
const artistNoteTextFirstPart = ref('');
const artistNoteTextSecondPart = ref('');
const artistNoteTextBox1 = ref(null);
const artistNotePage = ref(props.fieldVisibility.artistNote);
const isNoteError = ref(false)
const editorPlaceholder = `작가 노트는 한 페이지를 넘길 수 없으며, 초과된 분량은 자동으로 삭제됩니다.

띄어쓰기나 줄 바꿈 횟수에 따라 1,200자 내외의 글자를 입력할 수 있습니다.

메모장 등에서 미리 작성한 텍스트를 복사해 붙여넣는 것도 가능합니다.

우측 화면을 보면서 분량이나 띄어쓰기, 줄 바꿈 위치를 조정해보세요.
`;

function triggerErrorColor() {
  isNoteError.value = true;
  nextTick();
  setTimeout(() => {
    isNoteError.value = false;
  }, 1500)
}

// fieldVisibility 관리는 항상 프로필관리에서 하기로 변경. 여기서 업데이트x
function updateFieldVisibility(key, value) {
  emit('update:field-visibility', {...props.fieldVisibility, [key]: value})
}

const removeArtistNotePage = () => {
  if (!confirm('페이지를 삭제하시겠습니까? 아티스트 노트를 다시 추가하고 싶다면 포트폴리오 제작 초기 화면으로 돌아가 ‘새 포트폴리오 만들기’를 눌러주세요.')) {
    return;
  }
  artistNotePage.value = false;
  updateSwiper();
  //artist.value.artistNote = null;
  updateFieldVisibility('artistNote', false);
}

// ✅ 주어진 텍스트가 특정 높이 내에 들어갈 수 있는 최대 인덱스 계산
const findFittingIndex = (text, tempBox, maxHeight) => {
  const chars = text.split('')
  let left = 0, right = chars.length, fitIndex = 0;
  tempBox.textContent = '';

  // 이진 탐색
  while (left + 50 <= right) {
    const mid = Math.floor((left + right) / 2)
    tempBox.textContent = chars.slice(0, mid).join('')
    if (tempBox.scrollHeight > maxHeight) {
      right = mid - 1
    } else {
      fitIndex = mid
      left = mid + 1
    }
  }

  // 선형 보정
  for (let i = fitIndex + 1; i <= chars.length; i++) {
    tempBox.textContent = chars.slice(0, i).join('')
    if (tempBox.scrollHeight > maxHeight) {
      break
    }
    fitIndex = i
  }
  return fitIndex;
};

let isOver = true;
const splitText = debounce(() => {
  const boxEl = artistNoteTextBox1.value;
  if (!boxEl) {
    return
  }

  const fullText = artist.value.artistNote;
  if (!fullText) {
    artistNoteTextFirstPart.value = '';
    artistNoteTextSecondPart.value = '';
    return
  }

  const tempBox = getTempBox(boxEl, 'div', false);
  const boxHeight = tempBox.clientHeight || parseFloat(getComputedStyle(boxEl).height);

  tempBox.textContent = fullText;
  if (tempBox.scrollHeight <= boxHeight) {
    artistNoteTextFirstPart.value = fullText;
    artistNoteTextSecondPart.value = '';
    return;
  }

  // ✅ 첫 번째 박스 분할
  const firstIdx = findFittingIndex(fullText, tempBox, boxHeight);
  const first = fullText.slice(0, firstIdx);
  const rest = fullText.slice(firstIdx);

  // ✅ 두 번째 박스 분할
  let second = ''
  if (rest) {
    const secondIdx = findFittingIndex(rest, tempBox, boxHeight);
    second = rest.slice(0, secondIdx);
    if (rest.length > secondIdx) {
      triggerErrorColor();
      debounceAlert("초과된 분량이 자동 삭제되었습니다.");
      artist.value.artistNote = fullText.slice(0, secondIdx - rest.length);
    }
  }

  artistNoteTextFirstPart.value = first + ' &nbsp;&nbsp;&nbsp;&nbsp;';
  artistNoteTextSecondPart.value = second + ' &nbsp;&nbsp;&nbsp;&nbsp;';
}, 300);

const debounceAlert = debounce((message) => {
  alert(message);
}, 600)

watch(() => artist.value.artistNote, (newVal) => {
  splitText();
}, {immediate: true});

/** 작가 노트 e */

/** Swiper s */
const mainSwiper = ref(null);
const thumbnailSwiper = ref(null);

const updateSwiper = async () => {

  await nextTick();
  if (thumbnailSwiper.value) {
    thumbnailSwiper.value.update();
  }
  if (mainSwiper.value) {
    mainSwiper.value.update();
  }

  await nextTick();
  addClickEvent();
}
const initializeSwiper = async () => {
  await nextTick();

  //너무 느려서 요소 복사해서 css 주고 스케일로 화면조정하자.
  //const isThumbnails = await generateThumbnails(".main-swiper", ".thumbnail-swiper", 0.3);
  const isThumbnails = true;
  if (isThumbnails) {
    thumbnailSwiper.value = new Swiper('.thumbnail-swiper', {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: false,
      grabCursor: true,
      slideToClickedSlide: true,
      centeredSlides: true,
    });
  }

  mainSwiper.value = new Swiper('.main-swiper', {
    slidesPerView: 1,
    allowTouchMove: !isMobile.value,
    loop: false,
    grabCursor: true,
    mousewheel: false,
    keyboard: {
      enabled: true,
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    thumbs: {
      swiper: thumbnailSwiper.value
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    on: {
      slideChange: () => {
        if (thumbnailSwiper.value) {
          thumbnailSwiper.value.slideTo(mainSwiper.value.activeIndex, 200, true);
        }
      }
    }
  });
  await updateSwiper();
};

const destroySwiper = () => {
  if (mainSwiper.value && typeof mainSwiper.value.destroy === 'function') {
    mainSwiper.value.destroy(true, true);
    mainSwiper.value = null;
  }

  if (thumbnailSwiper.value && typeof thumbnailSwiper.value.destroy === 'function') {
    thumbnailSwiper.value.destroy(true, true);
    thumbnailSwiper.value = null;
  }
};

const isMobile = ref(window.innerWidth < 1050);

const generateThumbnails = async (mainSelector, thumbSelector, scale = 0.3) => {
  await nextTick();
  const mainSlides = document.querySelectorAll(`${mainSelector} .swiper-slide .inner`);
  const thumbnailWrapper = document.querySelector(`${thumbSelector} .swiper-wrapper`);

  if (!mainSlides.length || !thumbnailWrapper) {
    console.warn("📌 mainSlides 또는 thumbnailWrapper를 찾을 수 없음!");
    return;
  }

  for (const [index, inner] of Array.from(mainSlides).entries()) {
    try {
      const innerWidth = inner.scrollWidth;
      const innerHeight = inner.scrollHeight;

      const canvas = await html2canvas(inner, {allowTaint: false, useCORS: true, width: innerWidth, height: innerHeight, scale: scale});
      const imgData = canvas.toDataURL('image/png', 1);

      const thumbnailSlide = document.createElement("div");
      thumbnailSlide.classList.add("swiper-slide");

      const img = document.createElement("img");
      img.src = imgData;
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "contain";

      thumbnailSlide.appendChild(img);
      thumbnailWrapper.appendChild(thumbnailSlide);
      return true;
    } catch (error) {
      console.error("📌 썸네일 생성 중 오류 발생:", error);
    }
  }
};

/** Swiper e */

const setInitData = async () => {
  previewImageFile.value = props.fieldVisibility.imageUrl ? {
    url: await toBlobUrlWithUuid('artist-profile-img', await getPublicPresignedUrls(props.artist.imageUrl), props.blobUrlMap)
  } : {};
  artist.value.phoneNum = formatPhoneNumber(artist.value.phoneNum);
  artist.value.introduction = props.fieldVisibility.introduction ? artist.value.introduction : '';

  profilePageDataBlankEl.value = {...props.profilePageLayoutConfig.profilePageDataBlankEl};
  profilePageDataRowGap.value = props.profilePageLayoutConfig.profilePageDataRowGap || 0;
  splitModeProfilePage.value = props.profilePageLayoutConfig.splitModeProfilePage;

  await setProfileData();
  await paginateProfileData();
  await paginateArtWorksData();
  await watchProfilePageLayoutConfig();
}

onMounted(async () => {
  uiStore.showLoading(loadingMessage);
  await setInitData();
  await initializeSwiper();
  if (props.autoDownload) {
    await autoDownload();
  }
  uiStore.hideLoading();
});

watch(() => previewImageFile.value?.url, (newVal) => {
  uiStore.showOverlay();
});

onBeforeUnmount(async () => {
  await updateArtWorksPageAndSide();
  destroySwiper();
  destroyTempBox();
  uiStore.hideOverlay();
});

const closeModal = () => {
  window.history.back(); // 히스토리 정리
};

const handlePopState = (event) => {
  emit('close'); // 뒤로가기 시 모달 닫기
};

onMounted(() => {
  window.history.pushState({pdfModalOpen: true}, ''); // 히스토리 추가
  window.addEventListener('popstate', handlePopState);
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopState);
});
</script>


<style scoped>

.print-panel .portfolio-slide .slider .swiper-slide.mobile-style {
  flex-direction: column;
  align-items: center;
  position: relative;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box.mobile-style {
  position: absolute;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box.mobile-style.z-up {
  z-index: 1;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box.mobile-style .swiper-slide-button-box-title-wrap {
  /* border-bottom: none;
  border-right: 1px solid #999999; */
  word-break: keep-all;
  white-space: pre-line;
  overflow-wrap: break-word;
}


.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box-toggle {
  display: flex;
  align-items: center;
  gap: 9px;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box-toggle .btn {
  width: fit-content;
  display: inline-block;
  height: 29px;
  padding: 0 10px;
  border-radius: 5px;
  background: #1B1A1F;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  color: #fff;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box-toggle .btn.on {
  background-color: #FFF5E8;
  color: black;
}

.print-panel .portfolio-slide .slider .swiper-slide .swiper-slide-button-box-toggle .btn:hover {
}


.print-panel .portfolio-slide .slider .swiper-slide::-webkit-scrollbar,
.print-panel .portfolio-slide::-webkit-scrollbar {
  width: 10px;
}


.print-panel .portfolio-slide .slider .swiper-slide::-webkit-scrollbar-thumb,
.print-panel .portfolio-slide::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ffffff00;
  border: 2px solid #FFF3CE;
}

.print-panel .portfolio-slide .slider .swiper-slide::-webkit-scrollbar-track,
.print-panel .portfolio-slide::-webkit-scrollbar-track {
  background: transparent; /* 트랙 배경 */
}

.error-text-color {
  color: red !important;
}

.heart-color-border {
  border: 1px solid #FF5C00 !important;
  transition: border 0.3s ease;
}

.text-dashed-border {
  border: 1px dashed #009ddf;
}


</style>